import FilterCategoryTitle from './FilterCategoryTitle';
export default FilterCategoryTitle;
